import * as React from 'react';
import * as PropTypes from 'prop-types';
import {
  TableResponsive,
  Header,
  Body,
  Main,
  Wrapper,
  Footer,
  More
} from './styled';

interface Props {
  renderComponent?: React.ReactNode;
  children?: React.ReactNode;
}

const Content: React.FC<Props> = ({
  renderComponent,
  children
}) => {

  const [ show, setShow ] = React.useState(false);

  const handleClick = () => {
    setShow(!show);
  };

  return(
    <>
      <Wrapper show={show}>
        {children}
      </Wrapper>
      <Footer>
        <More onClick={handleClick}>
          { show ? 'Ver menos' : 'Ver más' }
        </More>
        {renderComponent}
      </Footer>
    </>
  );
};

Content.propTypes = {
  renderComponent: PropTypes.node,
  children: PropTypes.node
}

TableResponsive.Header = Header;
TableResponsive.Body = Body;
TableResponsive.Main = Main;
TableResponsive.Content = Content;

export { TableResponsive }
